module.exports = __webpack_public_path__ + "static/media/Satoshi_Light.5481680c.woff2";